module.exports = __webpack_public_path__ + "static/media/authorisedClinic.57fcd37c.png";